<nz-header class="ui-header">
  <img style="height: 28px" src="assets/logos/logo.png" alt="logo" />
  <ui-icon
    name="menu"
    color="#00bcd4"
    size="24px"
    [clickable]="true"
    (click)="setSidebarVisible(!sidebarVisible)"
  ></ui-icon>
</nz-header>

<nz-drawer
  class="ui-header-drawer"
  [nzClosable]="false"
  [nzVisible]="sidebarVisible"
  (nzVisibleChange)="setSidebarVisible(sidebarVisible)"
  nzPlacement="right"
  [nzWidth]="'100%'"
  nzWrapClassName="ui-header-drawer-wrapper"
  (nzOnClose)="setSidebarVisible(false)"
>
  <ng-container *nzDrawerContent>
    <nz-header class="ui-header">
      <img style="height: 28px" src="assets/logos/logo.png" alt="logo" />
      <ui-icon
        name="arrow-left"
        color="#00bcd4"
        size="24px"
        [clickable]="true"
        (click)="setSidebarVisible(!sidebarVisible)"
      ></ui-icon>
    </nz-header>

    <ng-content select="[collapsibleContent]"></ng-content>
  </ng-container>
</nz-drawer>
